/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { DeviceStatusCount } from "./DeviceStatusCount";
import {
    DeviceStatusCountFromJSON,
    DeviceStatusCountFromJSONTyped,
    DeviceStatusCountToJSON,
} from "./DeviceStatusCount";

/**
 *
 * @export
 * @interface DeviceStatusByDnspResponse
 */
export interface DeviceStatusByDnspResponse {
    /**
     *
     * @type {Array<DeviceStatusCount>}
     * @memberof DeviceStatusByDnspResponse
     */
    items?: Array<DeviceStatusCount>;
}

/**
 * Check if a given object implements the DeviceStatusByDnspResponse interface.
 */
export function instanceOfDeviceStatusByDnspResponse(
    value: object,
): value is DeviceStatusByDnspResponse {
    return true;
}

export function DeviceStatusByDnspResponseFromJSON(
    json: any,
): DeviceStatusByDnspResponse {
    return DeviceStatusByDnspResponseFromJSONTyped(json, false);
}

export function DeviceStatusByDnspResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DeviceStatusByDnspResponse {
    if (json == null) {
        return json;
    }
    return {
        items:
            json["items"] == null
                ? undefined
                : (json["items"] as Array<any>).map(DeviceStatusCountFromJSON),
    };
}

export function DeviceStatusByDnspResponseToJSON(
    value?: DeviceStatusByDnspResponse | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        items:
            value["items"] == null
                ? undefined
                : (value["items"] as Array<any>).map(DeviceStatusCountToJSON),
    };
}
